export const NAME = "errors";
